export enum TideForecastType {
	Undefined = 0,
	Level = 1,
	Low = 2,
	High = 4,
}

